import React from "react";
import { Label } from "@fluentui/react";
import { useCommonControlsStyle } from "../../../../theme/styles/CommonControlsStyle";
import logicalUnitImage from "../../../../assets/luError.png";

const loaderBorderStyle = {
  padding: "10px auto",
  bottom: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
};

const messageBorderStyle = {
  margin: "auto",
  width: "400px",
  paddingLeft: "0px",
};

const imageStyles = {
  maxWidth: "100%",
  maxHeight: "80%",
  width: "300px",
  height: "300px",
  objectFit: "contain",
  objectPosition: "center",
};

export function WorkingDocumentsErrorDisplay({ message }) {
  const styleTheme = useCommonControlsStyle();

  return (
    <div style={loaderBorderStyle}>
      <div style={messageBorderStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "10px",
          }}
        />
        <Label style={styleTheme.LabelErrorMessageStyle}>
          {message ?? ""}
        </Label>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            id="mainPageBackground"
            src={logicalUnitImage}
            style={imageStyles}
            alt="Welcome to Addovation Share"
          />
        </div>
      </div>
    </div>
  );
}
